<form [formGroup]="form">
  <div class="header">
    <div class="title">
      <fa-icon [icon]="getFaIcon('faChevronLeft')" class="backIcon" (click)="back()" matTooltip="Annuler l'édition"
        appChangeColorTheme attribute="color">
      </fa-icon>

      <h2>Édition d'une offre</h2>
      <fa-icon [icon]="getFaIcon('faLink')" class="copyLink" [matTooltip]="'Copier le lien de l\'offre'"
        *ngIf="mode === 'edit'" (click)="copyString()" appChangeColorTheme attribute="color"></fa-icon>

      <button matTooltip="Annuler l'édition" class="back" (click)="back()">Annuler</button>
    </div>

    <div class="type_of_offer">
      <div class="type_of_offer_action">
        <mat-slide-toggle formControlName="isInternalOffer" [color]="color">
          {{form.get('isInternalOffer').value ? 'Offre avec backoffice' : 'Offre sans backoffice'}}
        </mat-slide-toggle>
        <fa-icon [icon]="getFaIcon('faInfoCircle')" [matTooltip]="getTooltip('typeOfOfferAddEdit')" appChangeColorTheme
          attribute="color"></fa-icon>
      </div>
      <div class="type_of_offer_action" *ngIf="form.get('isInternalOffer').value">
        <mat-slide-toggle formControlName="hasSession" [color]="color"
          (click)="!offerSessionSettable ? disabledToggle(): null">
          {{form.get('hasSession').value ? 'Offre avec session' : 'Offre sans session'}}
        </mat-slide-toggle>
        <fa-icon [icon]="getFaIcon('faInfoCircle')" [matTooltip]="getTooltip('hasSession')" appChangeColorTheme
          attribute="color">
        </fa-icon>
      </div>
    </div>
  </div>

  <mat-tab-group [(selectedIndex)]="tabSelectedIndex" (selectedTabChange)="onTabChanged($event);">
    <mat-tab label="Description de l'offre">
      <app-admin-offer-edit-description *ngIf="!isLoading" [userConnected]="userConnected" [mode]="mode"
        [offer]="offer ?? null" [form]="form" [clubs]="clubs" [universes]="universes" (fileUpdate)="updateFile($event)"
        [parameters]="parameters" [practicesClub]="practicesClub" (editFinished)="editFinished.next($event)"
        (offerPreviewUpdate)="offerPreviewUpdate.next($event)"
        (imageUpdate)="imageUpdate.next($event)"></app-admin-offer-edit-description>

      <mat-spinner *ngIf="isLoading" style="margin: 0 auto;" color="primary" diameter="50"></mat-spinner>
    </mat-tab>

    <mat-tab label="Configuration du prix" *ngIf="form.get('isInternalOffer').value" [disabled]="form.invalid">
      <app-admin-offer-edit-pricing *ngIf="!isLoading" [userConnected]="userConnected" [mode]="mode" [offer]="offer"
        [form]="pricingForm" (editFinished)="editFinished.next($event)"
        (offerPreviewUpdate)="offerPreviewUpdate.next($event)"></app-admin-offer-edit-pricing>
    </mat-tab>
  </mat-tab-group>


  <div class="btn_action">
    <button class="back" type="button" matTooltip="Annuler l'édition" (click)="back()">Annuler</button>

    <button *ngIf="tabSelectedIndex === 1" class="back" type="button" matTooltip="Revenir à la description"
      (click)="tabSelectedIndex = 0">Précédent</button>

    <button (click)="onSubmit()" *ngIf="tabSelectedIndex === 0" class="confirm" type="button"
      [disabled]="!checkForm() || isLoading || form.invalid" [style.opacity]="checkForm() || isLoading ? 1 : .5"
      appChangeColorTheme attribute="bgc">
      {{ !form.get('isInternalOffer').value ? "Confirmer" : "Suivant" }}
    </button>

    <button (click)="onSubmit()" *ngIf="tabSelectedIndex === 1" type="button" class="confirm"
      [disabled]="isLoading || form.invalid || pricingForm.invalid || (!pricingForm.get('isPayableAtClub').value && !pricingForm.get('isPayableOnline').value)"
      [style.opacity]="form.invalid || pricingForm.invalid || (!pricingForm.get('isPayableAtClub').value && !pricingForm.get('isPayableOnline').value) ? .5 : 1"
      appChangeColorTheme attribute="bgc">Confirmer</button>
  </div>
</form>